import dayjs from 'dayjs'

export const formatDate = (date, format) => dayjs(date).format(format || 'MM/DD/YY')

export const getTodaysDate = () => formatDate(new Date())